/*
 * Created Date: Wednesday, September 7th 2022, 10:10:32 am
 * Author: Saudin Botonjic
 * License: Proprietary to Scaffcalc AB
 *
 * Copyright (c) 2022 Scaffcalc AB
 */

import { Tooltip } from "@mui/material";
import { FC, ReactElement, ReactNode } from "react";
import ThemeManager from "../../../../web/app/src/components/ThemeManager";

export interface ToolTipInterface {
  content: ReactNode;
  placement?: "right" | "left" | "top" | "bottom";
  children: ReactElement;
  alwaysOpen?: boolean;
}

const ToolTip: FC<ToolTipInterface> = (props) => {
  const { content, placement, children, alwaysOpen } = props;

  return (
    <ThemeManager>
      <Tooltip
        title={content}
        children={children}
        placement={placement}
        arrow
        open={alwaysOpen}
        PopperProps={{
          sx: {
            "& .MuiTooltip-tooltip": {
              fontSize: "14px",
              maxWidth: typeof content !== "string" ? "none" : "auto",
            },
          },
        }}
      />
    </ThemeManager>
  );
};

ToolTip.defaultProps = {
  placement: "right",
};

export default ToolTip;
